/* eslint-disable no-unused-vars */
import { memo } from 'react';
import { Typography } from '@mui/material';
import SectionLayout from 'components/common/SectionLayout';
import { useTranslation } from 'react-i18next';
import { CustomInput, TextField } from 'components';
import { useFacade } from './useFacade';
import { campaignEnvironment } from 'constants';
import uuid from 'react-uuid';

function CampaignName({ environment, expanded }) {
  const { t } = useTranslation();

  const {
    deleteCampaignName,
    onInputChange,
    selectedCampName,
    isAppName,
    isDate,
    handleClickGenBtn,
    isRightIcon,
    errorFlag,
    errorText,
  } = useFacade(environment, expanded);

  return (
    <SectionLayout
      leftSide={
        <Typography variant='subtitle2' component='h6'>
          {t('campaign.general_information.name.label')}:
        </Typography>
      }
      rightSide={
        <>
          <CustomInput
            onChange={onInputChange}
            autoComplete='off'
            value={selectedCampName ?? ''}
            rightIconOnClick={deleteCampaignName}
            id={`campaign_name_${uuid()}`}
            name={`campaign_name_${uuid()}`}
            rightIcon={isRightIcon}
            placeholder='{app_name} - {date}'
            error={errorFlag}
            errorText={errorText}
          />

          {environment === campaignEnvironment.new_empty && (
            <div style={nameStyle.inputContainer}>
              <span style={nameStyle.nameText}>{t('campaign.name_text')}</span>
              <button
                className={'placeholder-btn ' + (isAppName ? 'active' : '')}
                onClick={() => handleClickGenBtn('isAppName', !isAppName)}
              >
                {'{app_name}'}
              </button>{' '}
              ,
              <button
                className={'placeholder-btn ' + (isDate ? 'active' : '')}
                onClick={() => handleClickGenBtn('isDate', !isDate)}
              >
                {'{date}'}
              </button>
            </div>
          )}
        </>
      }
    />
  );
}

export default memo(CampaignName);

const nameStyle = {
  transparentInput: {
    position: 'absolute',
    background: 'transparent',
  },
  nameText: {
    fontSize: '12px',
    color: '#64748B',
  },
  inputContainer: {
    margin: '5px',
  },
  label: {
    fontSize: '14px',
    color: '#334155',
  },
};
